// extracted by mini-css-extract-plugin
export default {"container":"IssueTypeIndicator-module__container--Pqzj1"};